import { NavLink } from "react-router-dom";
import LocationIcon from "../../../assets/icons/LocationIcon";
import CompanyIcon from "../../../assets/icons/CompanyIcon";
import ProjectIcon from "../../../assets/icons/ProjectIcon";
import HomeIcon from "../../../assets/icons/HomeIcon";
import ContactIcon from "../../../assets/icons/ContactIcon";
import EmailIcon from "../../../assets/icons/EmailIcon";
import CloseIcon from "../../../assets/icons/CloseIcon";
import HamburgerIcon from "../../../assets/icons/HamburgerIcon";
import ArrowRight from "../../../assets/icons/ArrowRight";

const Sidebar = ({ openLargeSidebar, showLargeScreenNav }) => {
  const handleActiveNavLink = match => {
    if (!match?.isExact) {
      return false;
    }
    return true;
  };

  return (
    <section className="wrapper__menu__menu">
      <div
        className="d-sm-none d-lg-flex justify-content-center large-screen-hamburger"
        onClick={openLargeSidebar}
      >
        {showLargeScreenNav ? (
          <CloseIcon width="18" height="18" className="me-3 cursor-pointer" />
        ) : (
          <div className="d-none d-sm-none d-lg-flex cursor-pointer">
            <HamburgerIcon width="24" height="24" />
            <ArrowRight width="24" height="24" fill="white" />
          </div>
        )}
      </div>
      <NavLink
        to="/"
        className="wrapper__menu__menu__box"
        isActive={handleActiveNavLink}
        activeClassName="wrapper__menu__menu__box--active"
      >
        <HomeIcon width="24" height="25" fill="currentColor" />
        <div className="pt-1 ms-3 nav-link-text">Home</div>
      </NavLink>
      {/* <NavLink
        to="/project"
        className="wrapper__menu__menu__box"
        isActive={handleActiveNavLink}
        activeClassName="wrapper__menu__menu__box--active"
      >
        <ProjectIcon width="24" height="24" fill="currentColor" />
        <div className="pt-1 ms-3 nav-link-text">Projects Board</div>
      </NavLink>
      <NavLink
        to="/key"
        className="wrapper__menu__menu__box"
        isActive={handleActiveNavLink}
        activeClassName="wrapper__menu__menu__box--active"
      >
        <ContactIcon width="24" height="25" fill="currentColor" />
        <div className="pt-1 ms-3 nav-link-text">Key Contact Lists</div>
      </NavLink>
      <NavLink
        to="company"
        className="wrapper__menu__menu__box"
        isActive={handleActiveNavLink}
        activeClassName="wrapper__menu__menu__box--active"
      >
        <CompanyIcon
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="similar-icon me-1"
        />
        <div className="pt-1 ms-3 nav-link-text">Company Discovery</div>
      </NavLink>
      <NavLink
        to="management"
        className="wrapper__menu__menu__box"
        isActive={handleActiveNavLink}
        activeClassName="wrapper__menu__menu__box--active"
      >
        <LocationIcon
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
        />
        <div className="pt-1 ms-3 nav-link-text">Territory Management</div>
      </NavLink>
      <NavLink
        to="/activities"
        className="wrapper__menu__menu__box"
        isActive={handleActiveNavLink}
        activeClassName="wrapper__menu__menu__box--active"
      >
        <EmailIcon width="24" height="25" fill="currentColor" />
        <div className="pt-1 ms-3 nav-link-text">Activities</div>
      </NavLink> */}
    </section>
  );
};

export default Sidebar;
